import type { Usuario } from './tipos'

/**
 * Lo mismo que hace el servidor en Dominio\Permisos, para decidir qué se pinta.
 * Quien manda es el servidor: esto solo evita enseñar puertas cerradas.
 */
export const puede = (usuario: Usuario, permiso: string): boolean =>
  usuario.es_admin || usuario.permisos.includes(permiso)

/** Si tiene algo de esa rama, por ejemplo cualquier permiso de «personal». */
export const puedeAlgo = (usuario: Usuario, prefijo: string): boolean =>
  usuario.es_admin || usuario.permisos.some((permiso) => permiso.startsWith(prefijo))
